import empty from "is-empty";
import { isMarketDataFetched, isStoreRowValid } from "src/utils/validators";

export const ConfirmationSelectors = {
    GetReadyToRefresh: (state) => state.Confirmations.readyToRefresh,
    GetLiveMode: (state) => empty(state.Confirmations.tableStatus),
    GetEditMode: (state) => state.Confirmations.editMode,
    GetTableStatus: (state) => state.Confirmations.tableStatus,
    GetTableChanges: (state) => state.Confirmations.tableChanges,
    GetTableErrors: (state) => state.Confirmations.tableErrors,
    GetSelectedRows: (state) => state.Confirmations.selectedRows,
    GetCancelErrors: (state) => state.Confirmations.cancelErrors,
    GetNewUpdates: (state) => state.Confirmations.newUpdates,
    GetDetailConfirmation: (state) => state.Confirmations.selectedConfirmation,
    GetDetailOpened: (state) => state.Confirmations.selectedConfirmation,
    // Fixing redux immutable error
    GetStoreRows: (state) =>
        state.Confirmations.storeRows.map((row) => ({ ...row })),
    GetStoreSettings: (state) => state.Confirmations.storeSettings,
    GetStoreIsReady: (state) =>
        state.Confirmations.storeRows.reduce(
            (isValid, row) =>
                isValid &&
                isStoreRowValid(row) &&
                isMarketDataFetched(row.marketData),
            true
        ),
    GetStoreErrors: (state) => state.Confirmations.storeErrors,
    GetConfirmations: (state) => state.Confirmations.confirmations,
    GetConfirmationsFilterOptions: (state) =>
        state.Confirmations.confirmationsFilterOptions,
};
